// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer-layout_container__nTqqH"};